module.exports = __webpack_public_path__ + "img/lang_en.700715a3.svg";